import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Settings > Customers > Service requests (migration 102). One checkbox,
// saved on change: "Let on-call customers request service in the portal",
// on unless turned off (companies.settings.serviceRequestsPortalEnabled).
// Off hides the portal card; the owner can still enter requests on the
// customer card, and the route builder still greys on-call customers who have
// not asked. GET/PUT /api/settings/service-requests.
function ServiceRequestsSetting() {
  const [enabled, setEnabled] = useState(null);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    let live = true;
    axios.get(`${API_URL}/api/settings/service-requests`)
      .then((res) => { if (live) setEnabled(res.data.portalEnabled !== false); })
      .catch((err) => { if (live) setMessage({ type: 'error', text: err.response?.data?.error || 'Could not load the setting' }); });
    return () => { live = false; };
  }, []);

  const toggle = async (e) => {
    const next = e.target.checked;
    setEnabled(next);
    setSaving(true);
    setMessage({ type: '', text: '' });
    try {
      const res = await axios.put(`${API_URL}/api/settings/service-requests`, { portalEnabled: next });
      setEnabled(res.data.portalEnabled);
      setMessage({
        type: 'success',
        text: next
          ? 'On-call customers can request service in the portal'
          : 'The Request service card is hidden in the portal',
      });
    } catch (err) {
      setEnabled(!next);
      setMessage({ type: 'error', text: err.response?.data?.error || 'Failed to save' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="card mb-lg">
      <div className="card-header">
        <h2 className="card-title">Service Requests</h2>
        <p className="text-muted" style={{ fontSize: '0.875rem', marginTop: '4px' }}>
          On-call customers pick the days they want service. On the route builder and in Storm Mode,
          on-call customers who have not asked for the route&apos;s day are greyed out and left out of Add all.
        </p>
      </div>
      {message.text && (
        <div className={`alert alert-${message.type === 'error' ? 'error' : 'success'}`} aria-live="polite">{message.text}</div>
      )}
      {enabled === null ? (
        !message.text && <p className="text-muted">Loading...</p>
      ) : (
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="checkbox-label" style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={enabled}
              onChange={toggle}
              disabled={saving}
              style={{ marginTop: '3px' }}
            />
            <div>
              <span style={{ fontWeight: 500 }}>Let on-call customers request service in the portal</span>
              <p className="text-muted" style={{ fontSize: '0.875rem', marginTop: '4px', marginBottom: 0 }}>
                When off, the portal shows no Request service card. You can still add requests from a
                customer&apos;s card.
              </p>
            </div>
          </label>
        </div>
      )}
    </div>
  );
}

export default ServiceRequestsSetting;
